import { ApolloLink } from "@apollo/client";

interface Params {
  roleId?: string;
  userId?: string;
}

export const getAddAuthLink = ({ roleId, userId }: Params = {}) => {
  return new ApolloLink((operation, forward) => {
    operation.extensions.authentication = { roleId, userId };

    return forward(operation);
  });
};
